import * as React from "react";
import PropTypes from 'prop-types';

const SvgAlerts = props => {
  if (props.id !== "_svgalerts") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.8 24C4.8 13.402 13.403 4.8 24 4.8c10.6 0 19.2 8.602 19.2 19.2 0 10.599-8.6 19.2-19.2 19.2-10.598 0-19.2-8.602-19.2-19.2zM24 12.482a7.677 7.677 0 00-7.68 7.68h3.84A3.852 3.852 0 0124 16.32a3.852 3.852 0 013.84 3.842c0 1.687-1.112 2.54-2.36 3.495-1.59 1.22-3.4 2.606-3.4 6.105h3.84c0-2.105 1.366-3.297 2.767-4.522 1.477-1.29 2.994-2.615 2.994-5.078a7.677 7.677 0 00-7.68-7.68zM22.08 35.52h3.84v-3.838h-3.84v3.838z" fill="#E71324" /></svg>;
};

SvgAlerts.displayName = "_svgalerts";
SvgAlerts.propTypes = {
  id: PropTypes.string
};
SvgAlerts.defaultProps = {
  id: ''
};
export default SvgAlerts;